import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomeView.vue';
import Services from '../views/ServicesView.vue';
import Blog from '../views/BlogView.vue';
import Contact from '../views/ContactView.vue';
import Appointment from '../views/AppointmentView.vue';
import LoginView from '../views/LoginView.vue';
import DashboardView from '../views/DashboardView.vue';
import WhyChooseUs from '../views/WhyChooseUs.vue';
import DentalServices from '../views/DentalServices.vue';
import MeetOurDoctors from '../views/MeetOurDoctors.vue';
import TreatmentDetails from '../views/TreatmentDetails.vue';
import FaqView from "@/views/FaqView.vue";
import PatientReviews from "@/views/PatientReviews.vue";



const routes = [
  { path: '/', component: Home },
  { path: '/services', component: Services },
  { path: '/blog', component: Blog },
  { path: '/dental-clinic-in-vip-road', component: Contact },
  { path: '/book-appointment-dental-clinic-guwahati', component: Appointment },
  { path: '/login', name: 'Login', component: LoginView },
  { path: '/dashboard', name: 'Dashboard', component: DashboardView },
  { path: "/trusted-dental-clinic-in-guwahati", name: "WhyChooseUs", component: WhyChooseUs },
  { path: "/dental-services", name: "DentalServices", component: DentalServices },
  { path: "/experienced-dentists-in-guwahati", name: "MeetOurDoctors", component: MeetOurDoctors },
  { path: "/treatments/:slug", name: "TreatmentDetails", component: TreatmentDetails },
  { path: "/faq-dental-clinic-in-assam", name: "FaqView", component: FaqView },
  { path: "/patient-reviews-magnum-dental", name: "PatientReviews", component: PatientReviews },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // for browser back/forward
    if (savedPosition) {
      return savedPosition;
    }

    // always scroll to top on new page
    return { top: 0 };
  },
});

export default router;